import router from "../../router";
import axios from "axios";
import Vue from "vue";
axios.defaults.timeout = 25000;
axios.defaults.baseURL = process.env.API_ROOT;

const _self = Vue.prototype

const USERKEY = "ONLINE_USER_BACK"

//http request 拦截器
axios.interceptors.request.use(
  config => {
    let uinfo = JSON.parse(localStorage.getItem(USERKEY));
    let token = '';
    if (uinfo) {
      token = uinfo.token
    }
    if (
      config.headers["Content-Type"] == "multipart/form-data" ||
      config.headers["Content-Type"] == "arraybuffer"
    ) {} else {
      config.data = JSON.stringify(config.data);
      config.headers = {
        "Content-Type": "application/json",
        'token': token
      };
    }
    // if(token){
    //   config.params = {'token':token}
    // }
    // console.log(config)
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    let msgskuboxClass = 'sys-sku-alert'
    if (response.data.code == 1001) {
      if (!document.querySelector(`.${msgskuboxClass}`)) {
        _self.$confirm(response.data.info, '系统提示', {
          confirmButtonText: '立即试用',
          showCancelButton: false,
          customClass: msgskuboxClass,
          iconClass: 'el-icon-warning',
        }).then(() => {
          get(`/userMenu/dd/skuexperience?goodsCode=${response.data.data.goodsCode}`).then(
            res => {
              if (res.success) {
                _self.$message.success('试用成功，请刷新操作！')
              } else {
                _self.$message.error(res.info)
              }
            }
          )
        }).catch(() => {
          document.querySelector(`.${msgskuboxClass}`).classList.remove(msgskuboxClass);
        })
      }
      return;
    } else if (response.data.code == 1002) {
      if (!document.querySelector(`.${msgskuboxClass}`)) {
        // vip
        _self.$confirm(response.data.info, '系统提示', {
          confirmButtonText: '立即开通',
          showCancelButton: false,
          customClass: msgskuboxClass,
          iconClass: 'el-icon-warning',
        }).then(() => {
          get(`/userMenu/dd/skupageLink?goodsCode=${response.data.data.goodsCode}`).then(
            res => {
              if (res.success) {
                let url = 'https://www.treetask.cn/#/dd/sku?'
                let query = res.data.split('?')[1]
                url += query
                window.open(
                  `dingtalk://dingtalkclient/page/link?url=${encodeURIComponent(
                                    url + '&ddtab=true'
                                  )}`
                )
              }
            }
          )
        }).catch(() => {
          document.querySelector(`.${msgskuboxClass}`).classList.remove(msgskuboxClass);
        })
      }
      return;
    }
    if (response.data.code == 401 || response.data.code == 405) {
      logout()
    }

    return response;
  },
  error => {
    if (error.response != null) {
      switch (error.response.status) {
        case 401:
          ;
        case 405:
          logout()
          break;
        default:
          break;
      }
    }
    //hideLoading();
    return Promise.reject(error);
  }
);

function logout() {
  const msgboxClass = 'sys-logout-alert'
  let user = JSON.parse(localStorage.getItem(USERKEY));
  if (user) {
    if (!document.querySelector(`.${msgboxClass}`)) {
      _self.$alert('由于您长时间未操作，请重新登录', '系统提示', {
        confirmButtonText: '确定',
        showClose: false,
        customClass: msgboxClass,
        iconClass: 'el-icon-warning',
        callback: action => {
          localStorage.removeItem(USERKEY);
          router.push("/login");
        }
      });
    } else {
      localStorage.removeItem(USERKEY);
      router.push("/login");
    }
  }
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        console.info(err);
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function deleted(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

export function commonRequest(method, url, data) {
  return new Promise((resolve, reject) => {
    axios.request({
      method: method,
      url: url,
      data: (data = {})
    }).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/components/api/api.js